/* eslint-disable quote-props */
import * as moment from 'moment';
import {
  yesNo,
  yn,
  yesNoBlank,
  existsOrBlank,
} from './mapping-tools';
import { stripPhone, cleanDate } from './formatting';
import getAgentID from './getAgentID';

export default ({
  agent,
  quote,
  fields: res,
  plan,
  theme,
  confirmationNumber,
}) => {
  const {
    useCarrierPerms,
    cigna: { sourceID = 'EnrollHere' } = {},
  } = theme;

  let agentID;
  let agentNPN;
  console.log('agent: ', agent);
  if (useCarrierPerms) {
    const ids = getAgentID({ agent, quote });
    agentID = ids.agentID;
    agentNPN = ids.agentNPN;
  } else {
    agentNPN = agent.npn;
  }

  const pcpName = res.pcp_name || '';
  const pcpNameSplit = pcpName.trim().replaceAll('  ', ' ').split(' ');
  const pcpFname = pcpNameSplit.shift();
  const pcpLname = pcpNameSplit.join(' ');
  const isSEP = res.enrolltype === 'SEP';
  const premiumDeducted = yesNo(['rrb', 'ssi'].includes(res.paymeth));
  const premiumDirectPay = yesNo(!['rrb', 'ssi'].includes(res.paymeth));
  const premiumWithhold = ['rrb', 'ssi'].includes(res.paymeth) ? res.paymeth.toUpperCase() : '';
  const planYear = plan.PlanYear;
  const isEFT = res.paymeth === 'eft';
  const isCouponBook = ((res.paymeth === 'direct') || !res.paymeth); // if paymeth not populated default to coupon book
  const benefitStart = moment(res.effective_date).format('MMDDYYYY');
  const ltcfAddress = res.ltcf
    ? `${res.ltcf_addr_street1}${res.ltcf_addr_street2 ? ` ${res.ltcf_addr_street2}` : ''}, ${res.ltcf_addr_city}, ${res.ltcf_addr_state} ${res.ltcf_addr_zip}`
    : '';
  // res.onmedicaid is only displayed for DSNP plans. If res.medicaidnum is set append it to the field.
  const formattedMedicaid = (res.onmedicaid && res.medicaidnum) ? `Yes, ${res.medicaidnum}` : yesNoBlank(res.onmedicaid, '');
  // opts are H = Home or C = Cell. Field home_phone_type asks if the phone is mobile or not.
  // if the question is not answered we default to 'Home' type.
  const phoneType = res.home_phone_type ? 'C' : 'H';

  let race = '';
  let ethnicity = '';

  if (Array.isArray(res.race) && res.race.length) {
    race = res.race.join(',');
  }
  if (Array.isArray(res.ethnicity) && res.ethnicity.length) {
    ethnicity = res.ethnicity.join(',');
  }

  const formattedData = [
    { id: '01', col: 'ConfirmationNumber', val: confirmationNumber },
    { id: '02', col: 'SubmitDate', val: moment().format('MMDDYYYY') },
    { id: '03', col: 'ContractID', val: plan.ExternalContractID },
    { id: '04', col: 'PlanID', val: plan.ExternalPlanID },
    { id: '05', col: 'SegmentID', val: plan.ExternalSegmentID },
    { id: '06', col: 'ApplicantTitle', val: '' },
    { id: '07', col: 'ApplicantFirstName', val: res.first_name },
    { id: '08', col: 'ApplicantMiddleInitial', val: res.middle_name },
    { id: '09', col: 'ApplicantLastName', val: res.last_name },
    { id: '10', col: 'ApplicantBirthDate', val: moment(res.birthdate).format('MMDDYYYY') },
    { id: '11', col: 'ApplicantGender', val: (res.gender === 'male') ? 'M' : 'F' },
    { id: '12', col: 'ApplicantAddress1', val: res.street1 },
    { id: '13', col: 'ApplicantAddress2', val: res.street2 },
    { id: '14', col: 'ApplicantAddress3', val: '' },
    { id: '15', col: 'ApplicantCity', val: (res.city || '').slice(0, 30) },
    { id: '16', col: 'ApplicantCounty', val: res.county_name },
    { id: '17', col: 'ApplicantState', val: res.state.toUpperCase() },
    { id: '18', col: 'ApplicantZip', val: res.zipcode },
    { id: '19', col: 'ApplicantEmailAddress', val: res.email },
    { id: '20', col: 'ApplicantMBI', val: res.medicare_id },
    { id: '21', col: 'ApplicantSSN', val: '' }, // SSN of applicant for SNP DE (PA ONLY)
    { id: '22', col: 'MailingAddress1', val: res.samemail ? res.street1 : res.mailstreet1 },
    { id: '23', col: 'MailingAddress2', val: res.samemail ? res.street2 : res.mailstreet2 },
    { id: '24', col: 'MailingAddress3', val: '' },
    { id: '25', col: 'MailingCity', val: res.samemail ? res.city : res.mailcity },
    { id: '26', col: 'MailingState', val: res.samemail ? res.state : res.mailstate },
    { id: '27', col: 'MailingZip', val: res.samemail ? res.zipcode : res.mailzip },
    { id: '28', col: 'MedicarePartA', val: cleanDate(res.part_a_effective_date) },
    { id: '29', col: 'MedicarePartB', val: cleanDate(res.part_b_effective_date) },
    { id: '30', col: 'EmergencyContact', val: res.hasemer ? `${res.emerfname} ${res.emerlname}` : '' },
    { id: '31', col: 'EmergencyPhone', val: res.hasemer ? stripPhone(res.emertel) : '' },
    { id: '32', col: 'EmergencyRelationship', val: res.hasemer ? res.emerrel : '' },
    { id: '33', col: 'PremiumDeducted', val: premiumDeducted },
    { id: '34', col: 'PremiumSource', val: '' },
    { id: '35', col: 'OtherCoverage', val: yn(res.othercoverage) }, // applies to PDP, MAPD, SNP DE, PFFS-PD, CP-PD
    { id: '36', col: 'OtherCoverageName', val: res.othercoverage ? res.othercoverage_name : '' },
    { id: '37', col: 'OtherCoverageID', val: res.othercoverage ? res.othercoverage_num : '' },
    { id: '38', col: 'LongTerm', val: yn(res.ltcf) },
    { id: '39', col: 'LongTermName', val: res.ltcf ? res.ltcf_name : '' },
    { id: '40', col: 'LongTermAddress', val: ltcfAddress },
    { id: '41', col: 'LongTermPhone', val: res.ltcf ? stripPhone(res.ltcf_tel) : '' },
    { id: '42', col: 'AuthorizedRepName', val: res.ispoa ? `${res.poa_fname} ${res.poa_lname}` : '' },
    { id: '43', col: 'AuthorizedRepAddress', val: res.ispoa ? `${res.poa_addr_street1} ${res.poa_addr_street2 || ''}`.trim() : '' },
    { id: '44', col: 'AuthorizedRepCity', val: res.ispoa ? res.poa_addr_city : '' },
    { id: '45', col: 'AuthorizedRepState', val: res.ispoa ? res.poa_addr_state : '' },
    { id: '46', col: 'AuthorizedRepZip', val: res.ispoa ? res.poa_addr_zip : '' },
    { id: '47', col: 'AuthorizedRepPhone', val: res.ispoa ? res.poa_tel : '' },
    { id: '48', col: 'AuthorizedRepRelationship', val: res.ispoa ? res.poa_rel : '' },
    { id: '49', col: 'Language', val: res.preflang ? res.preflang : '' },
    { id: '50', col: 'WorkStatus', val: yn(res.willwork) },
    { id: '51', col: 'SpouseWorkStatus', val: yn(res.willworkspouse) },
    { id: '52', col: 'PCPFirstName', val: pcpFname },
    { id: '53', col: 'PCPLastName', val: pcpLname },
    { id: '54', col: 'PCPProviderID', val: res.pcp_num || '' },
    { id: '55', col: 'OtherCoverageGroup', val: res.othercoverage_group },
    { id: '56', col: 'AgentID', val: agentID },
    { id: '57', col: 'SubmitTime', val: moment().format() },
    { id: '58', col: 'PartDSubAppInd', val: '' }, // ignoring because opt (and we don't collect subsidy info)
    { id: '59', col: 'DeemedInd', val: '' }, // ignoring because opt (and we don't collect subsidy info)
    { id: '60', col: 'SubsidyPercentage', val: '' }, // ignoring because opt (and we don't collect subsidy info)
    { id: '61', col: 'DeemedReasonCode', val: '' }, // ignoring because opt (and we don't collect subsidy info)
    { id: '62', col: 'LISCopayLevelID', val: '' }, // ignoring because opt (and we don't collect subsidy info)
    { id: '63', col: 'DeemedCopayLevelID', val: '' }, // ignoring because opt (and we don't collect subsidy info)
    { id: '64', col: 'PartDOptOutSwitch', val: '' }, // ignoring because opt (and we don't collect subsidy info)
    { id: '65', col: 'SEPReasonCode', val: isSEP ? res.sep_code : '' },
    { id: '66', col: 'SEPDate', val: isSEP ? res.sep_date : '' },
    { id: '67', col: 'PremiumDirectPay', val: premiumDirectPay },
    { id: '68', col: 'EnrollmentPlanYear', val: planYear },
    { id: '69', col: 'PremiumWithhold', val: premiumWithhold },
    { id: '70', col: 'Blank3', val: '' },
    { id: '71', col: 'Blank4', val: '' },
    { id: '72', col: 'Blank5', val: '' },
    { id: '73', col: 'Blank6', val: '' },
    { id: '74', col: 'Blank7', val: '' },
    { id: '75', col: 'PremiumDeductEFT', val: yesNo(res.paymeth === 'eft') },
    { id: '76', col: 'PremiumDeductCreditCard', val: yesNo(res.paymeth === 'cc') },
    { id: '77', col: 'PremiumDeductSS', val: yesNo(res.paymeth === 'ssi') },
    { id: '78', col: 'PremiumDeductBill', val: yesNo(isCouponBook) },
    { id: '79', col: 'AgentFirstName', val: agent.firstName },
    { id: '80', col: 'AgentLastName', val: agent.lastName },
    { id: '81', col: 'AgentNationalID', val: agentNPN },
    { id: '82', col: 'AgentStateLicenseNumber', val: '' }, // we don't collect/store state license info on agents
    { id: '83', col: 'AgentIDHealthPlan', val: '' }, // N/A according to cigna doc
    { id: '84', col: 'AgencyName', val: '' }, // we don't collect/store agency name on Amerilife or Humana agents
    { id: '85', col: 'AgencyID', val: '' }, // we don't collect/store agency name on Amerilife or Humana agents
    { id: '86', col: 'SourceID', val: sourceID },
    { id: '87', col: 'OEC_InsertedWhen', val: '' }, // not applicable?
    { id: '88', col: 'MedicalGroupID', val: '' }, // not applicable?
    { id: '89', col: 'AccountName', val: isEFT ? res.eft_actname : '' },
    { id: '90', col: 'BankRoutingNum', val: isEFT ? res.eft_routing : '' },
    { id: '91', col: 'BankAccountNum', val: isEFT ? res.eft_actnum : '' },
    { id: '92', col: 'AccountType', val: isEFT ? res.eft_acttype : '' },

    // NOTE: THE FOLLOWING FIELDS CONTAIN THE DATA FOR
    //   CUSTOM QUESTIONS. CUSTOM QUESTIONS WILL ALWAYS
    //   BE AT THE END OF THE ENROLLMENT APPLICATION RECORD.
    //
    // options for EnrollmentType
    //   TEL - telephonic / agent
    //   ONL - online / unassisted
    //   VIR - virtual / agent
    //   FTF - face to face / agent
    { id: '93', col: 'EnrollmentType', val: 'TEL' },
    { id: '94', col: 'BenefitStart', val: benefitStart },
    { id: '95', col: 'Blank', val: '' },
    { id: '96', col: 'DentalCoverage', val: '' }, // opt
    { id: '97', col: 'DiabetesDiagnosis', val: yesNoBlank(res.snp_diabetes) }, // opt
    { id: '98', col: 'DiabetesMedication', val: existsOrBlank(res.snp_diabetes_medicines) }, // opt
    { id: '99', col: 'DiabetesProviderName', val: existsOrBlank(res.snp_physician_name) }, // opt
    { id: '100', col: 'DiabetesProviderAddress', val: existsOrBlank(res.snp_physician_street1) }, // opt
    { id: '101', col: 'DiabetesProviderPhone', val: existsOrBlank(res.snp_physician_tel) }, // opt
    { id: '102', col: 'DiabetesProviderFax', val: existsOrBlank(res.snp_physician_fax) }, // opt
    { id: '103', col: 'Question14', val: '' }, // ??
    { id: '104', col: 'Question15', val: '' }, // ??
    { id: '105', col: 'AccessibilityFormat', val: res.altwritten },
    { id: '106', col: 'EmailOptIn', val: yn(res.okemail) },
    { id: '107', col: 'EmailTips', val: '' }, // don't collect this info
    { id: '108', col: 'Notes', val: isSEP ? res.sep_other : '' },
    { id: '109', col: 'ApplicantPhone', val: stripPhone(res.home_phone) },
    { id: '110', col: 'ApplicantPhoneType', val: phoneType },
    { id: '111', col: 'ApplicantAltPhoneType', val: 'H' }, // opts are H = Home or C = Cell. Our form verbiage is for home only.
    { id: '112', col: 'ApplicantAltPhone', val: '' }, // don't collect this info
    { id: '113', col: 'ApplicantAltCell', val: '' }, // don't collect this info
    { id: '114', col: 'StateMedicaid', val: formattedMedicaid },
    { id: '115', col: 'MedicaidAccessNbr', val: existsOrBlank(res.medicaid_accessnum) },
    { id: '116', col: 'MedicaidCaseNumber', val: existsOrBlank(res.medicaid_casenum) },
    { id: '117', col: 'ExistingPatient', val: res.pcp_name ? yn(res.pcp_established) : '' },
    { id: '118', col: 'ChronicCondition', val: yesNoBlank(res.chronic_condition) },
    { id: '119', col: 'Ethnicity', val: ethnicity },
    { id: '120', col: 'Race', val: race },
    { id: '121', col: 'Gender', val: existsOrBlank(res.gender_identify) },
    { id: '122', col: 'GenderIdentityOther', val: existsOrBlank(res.gender_identify_other) },
    { id: '123', col: 'SelfIdentify', val: existsOrBlank(res.self_identify) },
    { id: '124', col: 'SelfIdentifyOther', val: existsOrBlank(res.self_identify_other) },
    { id: '125', col: 'IndividualRepName', val: '' }, // `${agent.firstName} ${agent.lastName}` },
    { id: '126', col: 'IndividualRepRelationship', val: '' }, // res.agent_relationship },
    { id: '127', col: 'NationalProducerNumber', val: agentNPN },
  ];

  return { formattedData, agentID };
};
